'use strict';

angular.module('menu')
    .component('mainMenu', {
        templateUrl: 'js/modules/menu/components/main-menu/template.html',
        controller: 'MainMenuController',
    });
